
import { Box, Button, Divider, IconButton, Tooltip, Typography, useMediaQuery } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Theme from '../../../Themes/main.theme';
import LaunchIcon from '@mui/icons-material/Launch';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import TableGridWithFilters from '../../../components/TablegridWithFilters/TableGridWithFilters/TableGridWithFilters';
import { GridColDef } from '@mui/x-data-grid';
import { FieldControllerTypes } from '../../../components/form_v2/types';
import { createSearchParamsFormat, eliminateOjectNotTruthyValues } from '../../../lib/helperFuncs';
import React, { SetStateAction } from 'react';
import DialogAction from '../../../components/Dialog/DialogAction';
import HttpService from '../../../services/HttpService';
import i18n from '../../../i18n';

interface TekmrioProps {
  sullogesOptions: any[];
  ergoTypeOptions: any[];
  tekmirioTypeOptions: any[];
}

const _initialValues = {
  foreasName: '',
  collectionIds: '',
  ergoTitle: '',
  ergoType: '',
  tekmirioType: '',
  keywords: '',
  toDate: '',
  fromDate: '',
  suntelestisName: '',
};

function Tekmirio(props: TekmrioProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [initialValues, setInitialValues] = React.useState(_initialValues);
  const [open, setOpen] = React.useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const [fetchUrl, setFetchUrl] = React.useState<string>(`${process.env.REACT_APP_BACKEND_URL}/tekmirio?is_public=1&${searchParams.toString()}`);
  const matchesXSbreakpoint = useMediaQuery('(max-width:768px)');

  const [foreis, setForeis] = React.useState<Array<{key: string, value: string}>>([]);

  document.title= t('Αναζήτηση στο Υλικό των Οπτικοακουστικών Φορέων'); 

  const {
    ergoTypeOptions,
    sullogesOptions,
    tekmirioTypeOptions,
  } = props;

  
  const fullScreen = [[
    {
      control: FieldControllerTypes.autoselect,
      label: t('Ονομασία Φορέα'),
      name: 'foreasName',
      id: 'foreasName',
      filtersDesign: true,
      options: foreis
    },
    {
      control: FieldControllerTypes.autocomplete,
      label: t('Τίτλος Συλλογής'),
      name: 'collectionIds',
      id: 'collectionIds',
      filtersDesign: true,
      options: sullogesOptions
    },
    {
      control: FieldControllerTypes.input,
      label: t('Τίτλος Έργου'),
      customLabel: true,
      name: 'ergoTitle',
      id: 'ergoTitle',
      filtersDesign: true,
    },
    {
      control: FieldControllerTypes.autocomplete,
      label: t('Τύπος Έργου'),
      name: 'ergoType',
      id: 'ergoType',
      filtersDesign: true,
      options: ergoTypeOptions
    }
  ],
  [
    {
      control: FieldControllerTypes.autocomplete,
      label: t('Τύπος Τεκμηρίου'),
      name: 'tekmirioType',
      id: 'tekmirioType',
      filtersDesign: true,
      options: tekmirioTypeOptions
    },
    {
      control: FieldControllerTypes.input,
      label: t('Λέξεις-Κλειδιά'),
      customLabel: true,
      name: 'keywords',
      id: 'keywords',
      filtersDesign: true,
    },
    {
      control: FieldControllerTypes.input,
      label: t('Έτος Από'),
      name: 'fromDate',
      id: 'fromDate',
      filtersDesign: true,
      type: 'number',
      positives_only: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      label: t('Έτος Έως'),
      name: 'toDate',
      id: 'toDate',
      filtersDesign: true,
      type: 'number',
      positives_only: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      label: t('Εμπλεκόμενοι'),
      customLabel: true,
      name: 'suntelestisName',
      id: 'suntelestisName',
      filtersDesign: true,
    },
  ]];

  const mobileFilter = [
    {
      control: FieldControllerTypes.autoselect,
      label: t('Ονομασία Φορέα'),
      name: 'foreasName',
      id: 'foreasName',
      filtersDesign: true,
      options: foreis
    },
    {
      control: FieldControllerTypes.autocomplete,
      label: t('Τίτλος Συλλογής'),
      name: 'collectionIds',
      id: 'collectionIds',
      filtersDesign: true,
      options: sullogesOptions
    },
    {
      control: FieldControllerTypes.input,
      label: t('Τίτλος Έργου'),
      customLabel: true,
      name: 'ergoTitle',
      id: 'ergoTitle',
      filtersDesign: true,
    },
    {
      control: FieldControllerTypes.autocomplete,
      label: t('Τύπος Έργου'),
      name: 'ergoType',
      id: 'ergoType',
      filtersDesign: true,
      options: ergoTypeOptions
    },
    {
      control: FieldControllerTypes.autocomplete,
      label: t('Τύπος Τεκμηρίου'),
      name: 'tekmirioType',
      id: 'tekmirioType',
      filtersDesign: true,
      options: tekmirioTypeOptions
    },
    {
      control: FieldControllerTypes.input,
      label: t('Λέξεις-Κλειδιά'),
      customLabel: true,
      name: 'keywords',
      id: 'keywords',
      filtersDesign: true,
    },
    {
      control: FieldControllerTypes.input,
      label: t('Έτος Από'),
      name: 'fromDate',
      id: 'fromDate',
      filtersDesign: true,
      type: 'number',
      positives_only: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      label: t('Έτος Έως'),
      name: 'toDate',
      id: 'toDate',
      filtersDesign: true,
      type: 'number',
      positives_only: true,
      customLabel: true
    },
    {
      control: FieldControllerTypes.input,
      label: t('Εμπλεκόμενοι'),
      customLabel: true,
      name: 'suntelestisName',
      id: 'suntelestisName',
      filtersDesign: true,
    },
  ];


  const columns: GridColDef[] = [
    {
      field: 'tekmirioTitle',
      headerName: t('Τίτλος Τεκμηρίου') || undefined ,
      minWidth: 365,
      renderCell: ({row}) => 
        i18n.language === 'el' 
          ? row?.['documents:documentsTitle']?.[0]?.['@value'] || '-'
          : row?.['documents:documentsEnTitle']?.[0]?.['@value'] || '-'
    },
    {
      field: 'tekmirioType',
      headerName: t('Τύπος Τεκμηρίου') || undefined,
      minWidth: 200,
      renderCell: ({row}) => t(row?.['documents:documentsType']?.[0]?.['@value']) || '-'
    },
    {
      field: 'collectionIds',
      headerName: t('Τίτλος Συλλογής') || undefined,
      minWidth: 400,
      renderCell: ({row}) =>row?.['documents:documentsRelationCollection']?.[0]?.['display_title'] || '-'
    },
    {
      field: 'foreasTitle',
      headerName: t('Τίτλος Φορέα') || undefined,
      minWidth: 400,
    },
    // {
    //   field: 'ergoTitle',
    //   headerName: t('Τίτλος Έργου') || undefined,
    //   minWidth: 260,
    //   renderCell: ({row}) =>row?.['documents:documentsRelationProject']?.[0]?.['display_title'] || '-'
    // },
    {
      field: 'info',
      headerName: t('Λεπτομέρειες') || undefined,
      minWidth: 150,
      sortable: false,
      renderCell: ({row}) => 
        <Tooltip PopperProps={{
          disablePortal: true
        }}
        title={t('Προβολή')}>
          <IconButton onClick={() => navigate(`/search-documents/details/${row['o:id']}`)}>
            <LaunchIcon color='primary'/></IconButton>
        </Tooltip>
    },
  ];

  const onSubmit = (values: any) => {    
    const x = createSearchParamsFormat(values);
    Object.keys(initialValues).map((value) => {
      searchParams.delete(value);
      setSearchParams(searchParams);
    });
    setFetchUrl(`${process.env.REACT_APP_BACKEND_URL}/tekmirio?${searchParams.toString()}&${createSearchParams(x).toString()}`);
    setSearchParams(`${searchParams.toString()}&${createSearchParams(x).toString()}`);
  };

  const getForeis = async() => {
    try {
      const resp = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/foreas?is_public=1`);
      const organisationResults = resp.data?.data?.map((x: any) => {
        return {
          key: i18n.language === 'el' 
            ? x['o:title']
            : x['organisations:organisationsEnNameEn']?.[0]?.['@value'], 
          value: x['o:id']
        };
      });
      setForeis(organisationResults);
    } catch (error) {
      console.error(error);
    }
  };

  // useEffect for initialValues of filters based on searchParams
  React.useEffect(() => {
    let _params = { ..._initialValues };
    for (const entry of searchParams.entries()) {
      const [param, value] = entry;
      if (searchParams.has(param) && param in _initialValues) {
        if (param === 'ergoType' || param === 'collectionIds' || param === 'tekmirioType') {
          const _x = value.split(',').map((valueOfParam: any) => {
            return {
              key: valueOfParam,
              value: valueOfParam
            };
          });
          _params = { ..._params, [param as string]: _x };
        } else _params = { ..._params, [param]: value };
      }
    }
    setInitialValues({ ..._params });
  }, []);

  React.useEffect(() => {
    getForeis();
  }, []);
  
  const concatData = async (rows: any[], setRows: SetStateAction<any>) => {
    //collection
    const collection_ids = rows.map(row => row['documents:documentsRelationCollection']?.[0]?.['value_resource_id']);    
    const collections_response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/collections/items`, {
      params: eliminateOjectNotTruthyValues({collection_ids})
    });
    const collectionTitleEn = collections_response.data?.data?.[0]?.['collections:collectionsEnTitle']?.[0]?.['@value'];
    //foreas
    const foreas_ids = collections_response.data?.data?.[0]?.['collections:collectionsRelateOrganisation']?.[0]?.['value_resource_id'];    
    const foreas_response = await HttpService.getAxiosClient().get(`${process.env.REACT_APP_BACKEND_URL}/foreas/items`, {
      params: eliminateOjectNotTruthyValues({foreas_ids})
    });
    const foreasTitleEn = foreas_response.data?.data?.[0]?.['organisations:organisationsEnNameEn']?.[0]?.['@value'];
    //ergo has to add en title

    const _rows = rows.map(row => {
      const foreasTitle = collections_response.data.data
        .find((data: any) => data['o:id'] == row['documents:documentsRelationCollection']?.[0]?.['value_resource_id'])
        ?.['collections:collectionsRelateOrganisation']?.[0]?.['display_title'] || '-';
      
      return {
        ...row,
        foreasTitle: i18n.language === 'el'
          ? foreasTitle
          : foreasTitleEn,
        ...(i18n.language === 'en' && {'documents:documentsRelationCollection': [{
          ...row['documents:documentsRelationCollection'][0],
          display_title: collectionTitleEn
        }] })
       
      };
      
    });
    
    setRows(_rows);
  };
  
  return (<>
    <Typography sx={{my: 2}} variant='h2'
      color={Theme?.labelColor?.main}>{t('Αναζήτηση στο Υλικό των Οπτικοακουστικών Φορέων')}</Typography>
    <Divider sx={{mb: 5, border: 1, color: Theme?.dividerColor?.main}}/>
    <TableGridWithFilters
      componentInBetween={
        <Box display='flex' justifyContent='end'
          mt={2}>
          <Button sx={{ marginRight: 1, marginTop: 1 }}
            startIcon={<LaunchIcon />}
            variant='contained'
            onClick={() => setOpen(true)}
          >
            {t('Υλικό Συλλογών ΕΚΟΜΕ')}     
          </Button>
        </Box>
      }
      responseDataFieldName='data'
      responseTotalCountFieldName = 'totalResults'
      sortingMode='server'
      paginationMode='server'
      pageSize={15}
      rowsPerPageOptions={[15, 30, 45]}
      initialValues={initialValues}
      filterFields={matchesXSbreakpoint
        ? mobileFilter
        : fullScreen}
      columns={columns}
      onFiltersChange={(values: any) => onSubmit(values)}
      hidePagination={false}
      resetFilters={true}
      fetchUrl={fetchUrl}
      ignoreFilters
      resetFiltersTo={_initialValues}
      onFetch={(data, setRowsArray) => concatData(data.data, setRowsArray)
      }
      customSetRows
    />
    <DialogAction
      title={`${t('Τεκμηρια που ανήκουν σε Συλλογες του ΕΚΟΜΕ')}`}
      mode='info'
      fullWidth
      maxWidth='xl'
      open={open}
      onAccept={() => undefined}
      handleClose={() => setOpen(false)}
      content={
        <TableGridWithFilters
          pageSize={15}
          paginationMode='server'
          rowsPerPageOptions={[15, 30, 45]}
          responseDataFieldName='data'
          responseTotalCountFieldName='totalResults'
          hideFilters
          sortingMode='server'
          columns={columns}
          fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/tekmirio?foreasName=425`}
          onFetch={(data, setRowsArray) => concatData(data.data, setRowsArray)
          }
          customSetRows
        />
      }
    />
  </>);
}

export default Tekmirio;